"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var SvgIcon_1 = __importDefault(require("@material-ui/core/es/SvgIcon/SvgIcon"));
var SoothsingerIcon = /** @class */ (function (_super) {
    __extends(SoothsingerIcon, _super);
    function SoothsingerIcon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SoothsingerIcon.prototype.render = function () {
        return (react_1.default.createElement(SvgIcon_1.default, null,
            react_1.default.createElement("svg", null,
                react_1.default.createElement("path", { d: "m 1.9107242,18.378154 C 0.69385421,18.040401 0.03410421,17.261466 0.03966421,16.169119 c 0.0108,-2.108257 2.97303999,-4.159656 5.51897999,-3.821926 0.64582,0.08567 0.66145,0.07933 0.58966,-0.23918 -0.18377,-0.81518 -1.58643,-9.4570134 -1.58643,-9.7740414 0,-0.761714 2.06814,-1.81306495 4.3489302,-2.21080095 1.3461696,-0.234753 3.8110296,-0.265887 5.1133196,-0.06459 1.12088,0.173255 2.78295,0.760018 3.07877,1.08690295 0.17267,0.190793 0.41493,1.765459 1.04431,6.7879539 0.88906,7.0949635 0.88849,7.0711665 0.1989,8.1635535 -0.75885,1.202077 -2.39247,2.073617 -4.06871,2.170653 -0.94765,0.05486 -1.15427,0.02098 -1.80051,-0.295194 -1.29777,-0.634942 -1.6654,-1.835826 -0.9819,-3.207445 0.44698,-0.896946 1.22552,-1.59841 2.37509,-2.139921 0.79862,-0.376198 1.05316,-0.42816 2.10813,-0.430356 1.08259,-0.0022 1.19984,-0.02773 1.19992,-0.260689 1.1e-4,-0.33537 -0.81527,-6.6883524 -0.88403,-6.8878444 -0.10004,-0.290236 -1.30386,-0.464907 -3.2041,-0.464907 -2.78433,0 -5.1111098,0.468328 -6.2888298,1.265797 -0.36549,0.247488 -0.4462,0.381473 -0.39395,0.654081 0.0361,0.1885589 0.38135,2.1068839 0.76713,4.2629454 0.78648,4.395437 0.78522,4.541673 -0.0489,5.635269 -1.21214,1.589229 -3.49595,2.455839 -5.21472,1.978774 z" }))));
    };
    return SoothsingerIcon;
}(react_1.Component));
exports.default = SoothsingerIcon;



//////////////////
// WEBPACK FOOTER
// ./src/components/icons/SoothsingerIcon.tsx
// module id = 796
// module chunks = 0